import type { ReactNode } from "react";

import useTranslations from "@/shared/lang/useTranslations";

export interface SwapsHeaderProps {
  /** Right-aligned action slot. Empty today; kept so the header matches the other module headers. */
  actions?: ReactNode;
}

/**
 * Page header for the swaps screen. Mirrors `CardsHeader` / `WalletsHeader` so the three surfaces share one
 * title treatment; the title used to live inside `SwapForm`, which meant it disappeared on the success
 * screen.
 */
export function SwapsHeader({ actions }: SwapsHeaderProps) {
  const { t } = useTranslations("swaps");

  return (
    <header className="flex flex-wrap items-center justify-between gap-4">
      <div className="min-w-0">
        <h1 className="truncate text-2xl font-semibold leading-tight tracking-tight text-foreground">
          {t("swap_title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("page_subtitle")}</p>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
